<script setup lang="ts">
import ChildUserLoginView from '../../views/ChildUserLoginView/ChildUserLoginView.vue';
import UserAuthPageDecoration from 'src/shared/components/UserAuthPageDecoration/UserAuthPageDecoration.vue';
import { styleFn } from 'shared/composables/usePage';

// interface Props {
//   // modelValue: string
// }

// defineProps<Props>()
</script>

<template>
  <q-page
    padding
    :style-fn="styleFn"
    class="column bg-dark"
  >
    <div class="col fit q-pt-xl">
      <ChildUserLoginView />

      <UserAuthPageDecoration v-if="!$q.platform.is.mobile" />
    </div>
  </q-page>
</template>
